import { render, staticRenderFns } from "./show.lists-entries.page.vue?vue&type=template&id=a8a7b196&scoped=true&"
import script from "./show.lists-entries.page.vue?vue&type=script&lang=js&"
export * from "./show.lists-entries.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a7b196",
  null
  
)

export default component.exports